import { useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import { Divider, Grid, Stack, Button, IconButton, FormControl, InputLabel as MuiInputLabel, Select, MenuItem } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

import MainCard from 'src/berry/ui-component/cards/MainCard.jsx';
import InputLabel from 'src/berry/ui-component/extended/Form/InputLabel.jsx';
import { gridSpacing } from 'src/berry/store/constant.jsx';

import { Controller } from 'react-hook-form';
import { TextField } from '@mui/material';
import PopupsContext from 'src/context/popups.jsx';
import WysiwygTextarea from 'src/ui/wysiwyg_textarea.jsx';
import FileSelector from 'src/components/file_selector/component.jsx';

const ContentItem = ({ control, index, content_items, setValue, watch, on_remove, popup_id, list, set_list }) => {
	const item = content_items?.[index] || { type: 'text', data: '' };
	const item_type = watch(`content[${index}].type`) || item.type;
	const item_data = watch(`content[${index}].data`) || item.data;

	return (
		<>
			<Grid item xs={12}>
				<Stack direction="row" spacing={2} alignItems="flex-start">
					<Grid container spacing={gridSpacing} sx={{ flex: 1 }}>
						<Grid item xs={12} md={3}>
							<Stack spacing={gridSpacing}>
								<InputLabel>Type</InputLabel>
								<Controller
									name={`content[${index}].type`}
									control={control}
									defaultValue={item.type}
									render={({ field }) => (
										<FormControl fullWidth>
											<MuiInputLabel id={`content-type-${index}`}>Type</MuiInputLabel>
											<Select {...field} labelId={`content-type-${index}`} label="Type">
												<MenuItem value="img">Image</MenuItem>
												<MenuItem value="header">Header</MenuItem>
												<MenuItem value="text">Text</MenuItem>
											</Select>
										</FormControl>
									)}
								/>
							</Stack>
						</Grid>

						<Grid item xs={12} md={9}>
							<Stack spacing={gridSpacing}>
								<InputLabel>Data</InputLabel>
								{item_type === 'img' ? (
									<FileSelector
										on_change={(data) => {
											setValue(`content[${index}].data`, data);
											if (list[popup_id]?.content?.[index]) {
												list[popup_id].content[index].data = data;
												set_list(list);
											}
										}}
										value={item_data}
									/>
								) : item_type === 'text' ? (
									<WysiwygTextarea name={`content[${index}].data`} control={control} />
								) : (
									<Controller
										name={`content[${index}].data`}
										control={control}
										defaultValue={item.data || ''}
										render={({ field }) => <TextField {...field} fullWidth />}
									/>
								)}
							</Stack>
						</Grid>
					</Grid>
					<IconButton color="error" onClick={on_remove} sx={{ mt: 4 }}>
						<DeleteIcon />
					</IconButton>
				</Stack>
			</Grid>
			<Grid item xs={12}>
				<Divider />
			</Grid>
		</>
	);
};

const Regular = () => {
	const navigate = useNavigate();
	const { id, app_uid } = useParams();
	const { list, set } = useContext(PopupsContext);

	const popup = list[id];

	const { header, subheader, content, back_label } = popup;

	const content_array = Array.isArray(content) ? content : [];

	const { handleSubmit, control, watch, setValue } = useForm({
		defaultValues: { header, subheader, content: content_array, back_label },
	});

	const back_to_list = () => navigate(`/dashboard/${app_uid}/popups`);

	const on_sumbit = (data) => {
		list[id] = { ...list[id], ...data };
		set(list);
		back_to_list();
	};

	return (
		<MainCard title="Edit Popup">
			<form onSubmit={handleSubmit(on_sumbit)}>
				<Grid container spacing={gridSpacing}>
					<Grid item md={6}>
						<Stack spacing={gridSpacing}>
							<InputLabel>Header</InputLabel>
							<Controller
								name="header"
								control={control}
								defaultValue=""
								render={({ field }) => <TextField {...field} fullWidth />}
							/>
						</Stack>
					</Grid>

					<Grid item md={6}>
						<Stack spacing={gridSpacing}>
							<InputLabel>Subheader</InputLabel>
							<Controller
								name="subheader"
								control={control}
								defaultValue=""
								render={({ field }) => <TextField {...field} fullWidth />}
							/>
						</Stack>
					</Grid>

					<Grid item xs={12}>
						<Divider />
					</Grid>

					<Grid item xs={12}>
						<Stack spacing={gridSpacing}>
							<Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between">
								<InputLabel>Content</InputLabel>
								<Button
									variant="outlined"
									size="small"
									startIcon={<AddIcon />}
									onClick={() => {
										const current_content = watch('content') || [];
										const new_item = { type: 'text', data: '' };
										setValue('content', [...current_content, new_item]);
										if (!list[id].content) list[id].content = [];
										list[id].content.push(new_item);
										set(list);
									}}
								>
									Add Item
								</Button>
							</Stack>
							{(watch('content') || []).map((_, index) => (
								<ContentItem
									key={index}
									control={control}
									index={index}
									content_items={watch('content')}
									setValue={setValue}
									watch={watch}
									on_remove={() => {
										const current_content = watch('content') || [];
										const new_content = current_content.filter((_, i) => i !== index);
										setValue('content', new_content);
										list[id].content = new_content;
										set(list);
									}}
									popup_id={id}
									list={list}
									set_list={set}
								/>
							))}
						</Stack>
					</Grid>

					<Grid item xs={12}>
						<Stack spacing={gridSpacing}>
							<InputLabel>Back Label</InputLabel>
							<Controller
								name="back_label"
								control={control}
								defaultValue=""
								render={({ field }) => <TextField {...field} fullWidth />}
							/>
						</Stack>
					</Grid>

					<Grid item xs={6}>
						<Button fullWidth variant="text" color="error" onClick={back_to_list}>
							Cancel
						</Button>
					</Grid>
					<Grid item xs={6}>
						<Button fullWidth variant="contained" type="submit">
							Save
						</Button>
					</Grid>
				</Grid>
			</form>
		</MainCard>
	);
};

export default Regular;
